import type { JSX } from 'react'

export const QualityIcon = (): JSX.Element => (
  <use href='#qualityIcon' height='100%' width='100%' />
)
